<ng-container [ngSwitch]="layout">
	<ng-container *ngSwitchCase="'inline'">
		<div class="d-flex align-items-center w-100">
			<div class="row flex-nowrap g-2 align-items-center promoted-content-card m-0 w-100">
				<ng-container *ngIf="shouldRenderImageColumn">
					<div class="col-auto img-container">
						<ng-container *ngIf="imageUrl; else imagePlaceholderInline">
							<img [src]="imageUrl" class="image-square" [alt]="imageAlt" />
						</ng-container>
						<ng-template #imagePlaceholderInline>
							<div class="image-square image-square--placeholder d-flex align-items-center justify-content-center">
								<i class="fal fa-home"></i>
							</div>
						</ng-template>
					</div>
				</ng-container>

				<div class="col m-auto">
					<ng-container *ngTemplateOutlet="listingDetails"></ng-container>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngSwitchDefault>
		<a class="text-decoration-none d-flex align-items-center h-100 w-100">
			<div class="row flex-nowrap g-2 align-items-center promoted-content-card m-0 w-100">
				<ng-container *ngIf="shouldRenderImageColumn">
					<div class="col-auto img-container">
						<ng-container *ngIf="imageUrl; else imagePlaceholder">
							<img [src]="imageUrl" class="image-square" [alt]="imageAlt" />
						</ng-container>
						<ng-template #imagePlaceholder>
							<div class="image-square image-square--placeholder d-flex align-items-center justify-content-center">
								<i class="fal fa-home"></i>
							</div>
						</ng-template>
					</div>
				</ng-container>

				<div class="col m-auto">
					<ng-container *ngTemplateOutlet="listingDetails"></ng-container>
				</div>
			</div>
		</a>
	</ng-container>
</ng-container>

<ng-template #listingDetails>
	<ng-container *ngIf="listing as current; else listingFallback">
		<p class="table-mbc__text mb-1" *ngIf="current.price !== undefined">
			<strong>
				{{ current.price | currency : 'USD' : 'symbol' : '1.2-2' }}
			</strong>
		</p>
		<p
			class="table-mbc__text mb-1"
			*ngIf="current.sqft !== undefined || current.bedrooms !== undefined || current.bathrooms"
		>
			<ng-container *ngIf="current.sqft as sqft">
				{{ 'searchProperties.table.area' | translate : { count: (sqft | number : '1.0-0') } }}
			</ng-container>
			<ng-container *ngIf="current.bedrooms !== undefined && current.bedrooms !== null">
				<span class="table-mbc__separator" *ngIf="current.sqft !== undefined">|</span>
				{{ 'searchProperties.table.beds' | translate : { count: current.bedrooms } }}
			</ng-container>
			<ng-container *ngIf="current.bathrooms">
				<span
					class="table-mbc__separator"
					*ngIf="current.sqft !== undefined || (current.bedrooms !== undefined && current.bedrooms !== null)"
					>|</span
				>
				{{ 'searchProperties.table.baths' | translate : { count: current.bathrooms } }}
			</ng-container>
		</p>
		<p class="detail-address" *ngIf="showAddress && current.address">{{ current.address }}</p>
	</ng-container>

	<ng-template #listingFallback>
		<p class="table-mbc__text mb-0 placeholder" *ngIf="loadingDetails">Loading details...</p>
		<p class="table-mbc__text mb-0" *ngIf="!loadingDetails">Details unavailable</p>
	</ng-template>
</ng-template>
